import { buildDemoCommunicationNetworkGraphSummaryCards } from '@web/lib/demo/communicationNetworkGraph/summaryCards';
export var communicationNetworkGraphSummaryCards = function (input) { return ({
    summaryCards: buildDemoCommunicationNetworkGraphSummaryCards(input.orgUnitId === null)
}); };
